<template>
    <div :class="theme.wrapper">
        <div :class="theme.left">
            <app-button-control
                v-if="config.buttons_location === 'bottom-left'"
                :data="data"
            />
            <app-page-size-control v-else :data="data" />
        </div>

        <div :class="theme.right">
            <app-page-control ref="pageControl" :data="data" />
        </div>
    </div>
</template>

<script>
import PageControl from './PageControl.vue';
import ButtonControl from './ButtonControl.vue';
import PageSizeControl from './PageSizeControl.vue';
import Common from './mixins/Common.vue';

export default {
    components: {
        'app-page-control': PageControl,
        'app-button-control': ButtonControl,
        'app-page-size-control': PageSizeControl,
    },
    mixins: [Common],
    props: {
        data: Object,
    },
    mounted() {
        const updateHeight = () =>
            (this.data.footerHeight = $(this.$el).outerHeight());

        updateHeight();

        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(updateHeight);
            observer.observe(this.$el);
            this.$once('hook:destroyed', () => {
                observer.disconnect();
            });
        }
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/footer.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/footer.scss"
></style>
